export const APP_SCROLLER_ID = 'app-scroll';

/** The element the signed-in screens scroll in (see Layout). */
export const appScroller = () => document.getElementById(APP_SCROLLER_ID);
